import { Emitter } from "@irrelon/emitter";

export interface LayoutSupportedEvents {
    SectionRendered: (selector: string) => void;
}

export const layoutEmitter = new Emitter<LayoutSupportedEvents>();